<template>
  <div>
    <h2>Events</h2>
    <v-layout row class="house__selected-rooms ml-0 mr-0">
      <template v-if="selectedHouse.room.length > 0">
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-content
            v-for="(room, i) in selectedHouse.room"
            :key="i"
          >
            <template v-slot:header>
              <div>{{ room.name }}</div>
            </template>
            <v-list v-if="room.areas.length > 0" dense>
              <v-list-tile v-for="(area, index) in room.areas" :key="index">
                <v-list-tile-content>
                  <v-list-tile-title
                    class="body-1"
                    v-text="area.area"
                  ></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TenantPanel',
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse'
    })
  }
}
</script>
